import { RiCloseFill } from "react-icons/ri"
import { useTranslation } from "react-i18next"
import { AbsoluteContainer, AppLink, AppText, AuthOtpLabel, Button, FlexColumn, FlexRow, Form, GridContainer, SidePopupContainer } from "src/style"
import { ReactComponent as PasswordIcon } from 'src/assets/img/secure-password-icon.svg'
import { handleTypeNumberControl } from "src/utils/utility"
import ResendIcon from 'src/assets/svg/resend-icon'
import { ResetInput } from 'src/componentv2/Curated/SignIn/types'

interface OTPVerification2Props {
    onInput: (e: React.ChangeEvent<HTMLInputElement>) => void
    formData: ResetInput
    handleNext: () => void
    handleResend: () => void
    close: () => void
    error?: boolean
    maskedEmail?: string
}

export const OTPVerification2: React.FC<OTPVerification2Props> = ({ onInput, formData, handleNext, handleResend, close, error, maskedEmail }) => {
    const { t } = useTranslation()
    const errorColor = error ? '#F04438' : undefined

    function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        handleNext()
    }

    return (
        <>
            <SidePopupContainer zIndex="8" onClick={close} />
            <FlexColumn
                className="new-ads-container"
                justifyContent="flex-start"
                alignItems="flex-start"
            >
                <AbsoluteContainer top='1.5' right='1.5'>
                    <Button
                        titleSize="2" fontWeight="500"
                        width='3.4' shadow='none'
                        height='3.4'
                        radius='0.4'
                        bgColor='#ffffff'
                        hoverBgColor='#FEF3F2'
                        borderColor='none'
                        color='#000000'
                        hoverColor='#B42318'
                        onClick={close}
                    >
                        <RiCloseFill style={{ fontSize: '2.3rem' }} />
                    </Button>
                </AbsoluteContainer>
                <AppText color='#101828' textSize="1.8" fontWeight="700" fontFamily="Gilmer-Bold">
                    {t('login.otp.title')}
                </AppText>
                <GridContainer topMargin="2">
                    <PasswordIcon />
                </GridContainer>
                <AppText color="#000000" topMargin="1">
                    {t('login.otp.instruction', { maskedEmail: maskedEmail || 'your email' })}
                </AppText>
                <Form onSubmit={handleProceed}>
                    <GridContainer>
                        <FlexRow
                            width="auto" sizeUnit=""
                            topMargin='2' gap='1.4'
                            justifyContent="center"
                        >
                            <input
                                className='display-hidden' id='otp'
                                name="otp" value={formData?.otp}
                                onChange={onInput} type='number'
                                onKeyDown={handleTypeNumberControl}
                                onKeyUp={handleTypeNumberControl}
                                autoFocus={true} autoComplete="off"
                            />
                            <AuthOtpLabel className={`${formData?.otp.length === 0 ? 'active-otp-box' : ''}`} htmlFor='otp' borderColor={errorColor} color={errorColor}>{formData?.otp[0] ? '*' : ''}</AuthOtpLabel>
                            <AuthOtpLabel className={`${formData?.otp.length === 1 ? 'active-otp-box' : ''}`} htmlFor='otp' borderColor={errorColor} color={errorColor}>{formData?.otp[1] ? '*' : ''}</AuthOtpLabel>
                            <AuthOtpLabel className={`${formData?.otp.length === 2 ? 'active-otp-box' : ''}`} htmlFor='otp' borderColor={errorColor} color={errorColor}>{formData?.otp[2] ? '*' : ''}</AuthOtpLabel>
                            <AuthOtpLabel className={`${formData?.otp.length === 3 ? 'active-otp-box' : ''}`} htmlFor='otp' borderColor={errorColor} color={errorColor}>{formData?.otp[3] ? '*' : ''}</AuthOtpLabel>
                            <AuthOtpLabel className={`${formData?.otp.length === 4 ? 'active-otp-box' : ''}`} htmlFor='otp' borderColor={errorColor} color={errorColor}>{formData?.otp[4] ? '*' : ''}</AuthOtpLabel>
                            <AuthOtpLabel className={`${formData?.otp.length >= 5 ? 'active-otp-box' : ''}`} htmlFor='otp' borderColor={errorColor} color={errorColor}>{formData?.otp[5] ? '*' : ''}</AuthOtpLabel>
                        </FlexRow>
                        {error &&
                            <AppText textSize="1.3" color="#F04438" topMargin="1" align="center">
                                {t('login.otp.error')}
                            </AppText>
                        }
                    </GridContainer>
                    <FlexRow
                        gap='1.5'
                        bgColor='#E7F6F5' minHeight='6.2' radius='0.8'
                        shadow='0px 1px 2px rgba(16, 24, 40, 0.05)'
                        padding='2' topPadding='1' bottomPadding='1'
                        topMargin='2.5' bottomMargin="3"
                        justifyContent="flex-start"
                    >
                        <ResendIcon className='icon-component' />
                        <AppText textSize='1.2' color='#0A756F'>
                            {t('login.otp.resendText')}
                            <AppLink
                                textSize='1.2' color='#0A756F'
                                fontWeight='700' hoverColor='#000000'
                                leftMargin="1"
                                onClick={handleResend}
                            >
                                {t('login.otp.resendLink')}
                            </AppLink>
                        </AppText>
                    </FlexRow>
                    <FlexRow justifyContent='flex-end'>
                        <Button
                            width='8.8'
                            titleSize='1.4' fontWeight='600'
                            height='4' radius='0.8'
                            bottomMargin='1' hoverColor='#0D968F'
                            hoverBgColor='#fff' borderColor='#0D968F'
                        >
                            {t('login.otp.proceedButton')}
                        </Button>
                    </FlexRow>
                </Form>
            </FlexColumn>
        </>
    )
}